module.exports = __webpack_public_path__ + "img/qrcode.20a6f685.png";